<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees class="row my-5"></app-nav-gestion-donnees>

	<div *ngIf="role" class="row my-3 theme-main-color">
		<div class="row">
			<div class="d-flex justify-content-between">
				<div class="hand-cursor">
					<span (click)="goBack()" class="fs-4"
						><i class="bi bi-arrow-left me-3" aria-hidden="true"></i
						>{{ role.name}}</span
					>
				</div>

				<div class="">
					<a
						(click)="openModal(deleteRole)"
						class="btn theme-red-button px-4"
					>
						Supprimer la fiche
					</a>
				</div>
			</div>
			<div class="row my-5">
				<span class="fw-bold fs-5">Informations</span>
			</div>
		</div>
		<div class="rounded bg-light">
			<div *ngIf="isFormReadOnly">
				<div class="row my-4">
					<div class="col-12 col-lg">
						<label for="name" class="form-label fw-bold"
							>Nom</label
						>
						<span class="form-control-plaintext">{{
							role?.name
						}}</span>
					</div>
					<div *ngIf="role.description" class="col-12 col-lg-6">
						<label for="description" class="form-label fw-bold">Description</label>
						<span class="form-control-plaintext" id="description">{{
							role.description
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<label for="permissions" class="form-label fw-bold"
						>Permission(s)</label
					>
					<div class="row">
						<span class="col-12 col-lg text-dark">{{
							permissionsAsString()
						}}</span>
					</div>
				</div>
				


			</div>
			<app-role-form
				*ngIf="!isFormReadOnly"
				[role]="role"
				[isAddForm]="false"
				[form]="form"
				[isAddressSelected]="isAddressSelected"
				[isAddressDefault]="isAddressDefault"
				[isValidateButtonClicked]="isValidateButtonClicked"
				(sendForm)="onSubmit()">
			</app-role-form>

		</div>
		<div class="row my-4">
			<div class="d-flex justify-content-end">
				<button
					*ngIf="isFormReadOnly"
					class="btn theme-main-color-button"
					(click)="editForm()"
				>
					<i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier les
					informations
				</button>
				<button
					*ngIf="!isFormReadOnly"
					class="btn theme-main-color-button mx-3 px-3"
					(click)="stopEditForm()"
				>
					Annuler
				</button>
				<button
					*ngIf="!isFormReadOnly"
					[disabled]="!form.valid || isValidateButtonClicked.value"
					class="btn theme-green-button"
					type="submit"
					form="form"
				>
					<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
				</button>
			</div>
		</div>
	</div>

	<ng-template #deleteRole>
		<div class="modal-header text-center">
			<h4>Suppression {{ labelRoleCapitalized }}</h4>
			<button
				type="button"
				class="btn-close pull-right"
				data-bs-dismiss="modal"
				aria-label="Close"
				(click)="confirmDeleteModalRef.hide()"
			></button>
		</div>
		<div class="modal-body">
			Êtes-vous sûr de vouloir effectuer la suppression ?
		</div>
		<div class="modal-footer">
			<a
				(click)="confirmDeleteModalRef.hide()"
				class="btn theme-main-color-button"
				>Retour</a
			>
			<a class="btn theme-red-button ms-3" (click)="delete(role)"
				>Supprimer</a
			>
		</div>
	</ng-template>
</div>
